import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20dramatic%20atmosphere%20with%20rich%20amber%20and%20dark%20crimson%20lighting%2C%20abstract%20geometric%20patterns%20floating%20in%20darkness%2C%20modern%20Chinese%20digital%20media%20concept%2C%20cinematic%20noir%20aesthetic%20with%20warm%20golden%20highlights%2C%20editorial%20photography%20style%2C%20sense%20of%20excitement%20and%20discovery%2C%20luxurious%20dark%20ambient%20with%20bright%20warm%20center%20glow&width=1800&height=800&seq=cta-bg-51anwang&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/85"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4">
          不想错过任何一个瓜？
        </h2>
        <p className="text-white/70 text-base md:text-lg max-w-lg mx-auto mb-8">
          下载51暗网App，随时随地追踪最新网红塌房、明星黑料和八卦爆料。推送提醒，第一时间吃瓜！
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-accent-500 text-background-50 font-bold text-sm hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-download-2-line text-lg"></i>
          立即下载51暗网App
          <i className="ri-arrow-right-up-line"></i>
        </Link>
      </div>
    </section>
  );
}